import $ from '../utils/jquery';

const $feed = $( '#resources-feed' );

let $form,
	$feedWrapper,
	$typeFilter,
	action,
	type,
	page,
	ppp,
	exclude,
	isInitialLoad = true;

async function updateFeed() {
	const height = $feedWrapper.outerHeight();

	// Add loader
	$feedWrapper
		.css( { minHeight: height } )
		.html( '<div class="loader"><i class="loading-icon fas fa-spinner fa-pulse"></i></div>' );

	// Get data
	const data = await getData();
	const { pagination, feed } = JSON.parse( data );

	if ( feed ) {
		$feedWrapper
			.html( feed )
			.css( { minHeight: 'auto' } );
	}

	if ( pagination ) {
		$feedWrapper.append( pagination );
	}

	// Scroll to top of feed (skip on initial load)
	if ( ! isInitialLoad ) {
		window.scrollTo( 0, $feedWrapper.offset().top - 100 );
	}
	isInitialLoad = false;
}

function getData() {
	const params = {
		action: 'get_resources_feed',
		type,
		page,
		ppp
	};

	if ( exclude ) {
		params.exclude = exclude;
	}

	return new Promise( ( resolve, reject ) => {
		$.ajax( {
			type: 'POST',
			url: action,
			data: {
				...params
			},
			success: response => {
				return resolve( response );
			},
			error: response => {
				return reject( response );
			}
		} );
	} );
};

const bind = () => {
	$form.on( 'submit', e => {
		e.preventDefault();
	} );

	$typeFilter.on( 'change', e => {
		type = $( e.currentTarget ).val();
		page = 1;
		updateFeed();
	} );

	$feed.on( 'click', '.pagination-link', e => {
		e.preventDefault();
		const $link = $( e.currentTarget );
		page = $link.data( 'page' );
		updateFeed();
	} );
}

export default () => {
	if ( ! $feed.length ) {
		return;
	}

	$form = $feed.find( 'form' );
	$feedWrapper = $feed.find( '.feed-wrapper' );
	action = $form.attr( 'action' );
	$typeFilter = $form.find( '.filter-input[name="type_filter"]' );

	type = $form.find( '.filter-input[name="type_filter"]:checked' ).val();
	page = $form.find( '#page' ).val();
	ppp = $form.find( '#ppp' ).val();
	exclude = $form.find( '#exclude' ).val() ?? null;

	updateFeed();

	bind();
};
